import {validatePhone} from "./tech.phone";
import {getSelectedCountryCode, sendTrackLead, trackingCookieEnabled} from "./tech.core";

var courseTitle = $('.course-detail-page .course-detail-banner #courseTitle');
var scrollSpyContainer = $('.scroll-spy');
var offsetToActivateMenuTitle = 1000;
var courseDetailElem = $('#course-detail')
var dossierDownloadTopBtn = $('.dossier-download');
var footer = $('.footer');
var infoBottomBar = $('.info-enrol')
var offsetCourseDetailsElem = 1000;
var offsetFooter = 10000;
var coursePriceFloatingBadge = null;
var offsetToActivateFloatingBadge = 1000;
var offsetToActivateCourseDossierDownloadBtn = 2000;
var courseDossierDownloadBtn = $('.course-detail-page .fixed-download')
var sloganMobile = $('.slogan-mobile');
var itemToRecalculateOffset = $('.offset-trigger');
var itemToLoadCourseContent = $('#secondary-content-placeholder');
var domCourseContent = $('#course-data-info');
var offsetToLoadCourseContent = 200;
var offsetRecalculated = false;
var dossierValidatorLoaded = false;
var demoValidatorLoaded = false;
var moreInfoValidatorLoaded = false;
var seePriceValidatorLoaded = false;
var courseContentLoaded = false;
var body = $('body');
var player = null;
var activeSlideVideo = false;
var badgeAnimating = false;

var recurrentFeeFormatPrice = "";
var currencyPrice = "";
var currencyFormatPrice = "";
var priceFormatPrice = "";
var splitPaymentOnlyPrice = false;

const phoneUtil = require('google-libphonenumber').PhoneNumberUtil.getInstance();


export function SendCourseViewContentGtm() {
    //GET VALUES TO CREATE OBJ TO SEND TO GTM
    const courseDataInfo = document.getElementById('course-data-info');
    let courseId = courseDataInfo.getAttribute('data-course-code');
    let courseName = courseDataInfo.getAttribute('data-course-title');
    let courseValue = courseDataInfo.getAttribute('data-course-price-value');
    let courseCurrency = courseDataInfo.getAttribute('data-course-currency');
    tech.core.sendGAEvent({
        event: 'TechCourseViewContent',
        content_type: 'product',
        content_ids: [courseId],
        content_name: courseName,
        content_category: 'Cursos',
        currency: courseCurrency,
        value: courseValue
    })
}

function switchMenuTitle(show) {
    if (show) {
        $('.app-menu-header .options-section-header').addClass('d-none')
        $('.app-menu-header .title-section-header').removeClass('d-none')
        $('app-header a').addClass('fadeOut')
    } else {
        $('.app-menu-header .options-section-header').removeClass('d-none')
        $('.app-menu-header .title-section-header').addClass('d-none')
        $('app-header a').removeClass('fadeOut')
    }
}


function moveOnScroll(currentScroll, oldScroll) {
    if ($(document.body).hasClass('scrolling-up')) {
        sloganMobile.hide();
    } else {
        if (courseDossierDownloadBtn.hasClass('fixed-icon')) {
            sloganMobile.hide();
        } else {
            sloganMobile.show();
        }
    }
    if (currentScroll > oldScroll) {
        // scrolling downwards
        if (!offsetRecalculated && currentScroll > itemToRecalculateOffset.offset().top) {
            offsetRecalculated = true;
            calculateAnimationOffsets();
        }
        if (currentScroll > offsetToActivateMenuTitle) {
            switchMenuTitle(true);
        }
        if (coursePriceFloatingBadge !== null && currentScroll > offsetToActivateFloatingBadge + 10) {
            if (!coursePriceFloatingBadge.is('.floating')) {
                coursePriceFloatingBadge.addClass('fadeOut');
                setTimeout(function() {
                    coursePriceFloatingBadge.removeClass('fadeOut').addClass('floating');
                }, 500)
            } else {
                coursePriceFloatingBadge.removeClass('fadeOut');
            }
        }

    } else {

        switchMenuTitle(false);

        if (coursePriceFloatingBadge !== null && currentScroll <= offsetToActivateFloatingBadge - 10) {
            if (coursePriceFloatingBadge.is('.floating')) {
                if (activeSlideVideo) {
                    coursePriceFloatingBadge.addClass('fadeOut');
                } else {
                    coursePriceFloatingBadge.addClass('fadeOut');
                    setTimeout(function() {
                        coursePriceFloatingBadge.removeClass('fadeOut floating');
                    }, 500)
                }
            }
        }

    }
    if (currentScroll > offsetToActivateCourseDossierDownloadBtn + 10 && currentScroll < offsetFooter - 310) {
        courseDossierDownloadBtn.addClass('fixed-icon');
    }
    if (currentScroll <= offsetToActivateCourseDossierDownloadBtn - 10 || currentScroll >= offsetFooter - 290) {
        courseDossierDownloadBtn.removeClass('fixed-icon');
    }

    if (currentScroll > offsetCourseDetailsElem + 10) {
        infoBottomBar.show(300).css('display', 'flex');
    } else if (currentScroll <= offsetCourseDetailsElem - 10) {
        infoBottomBar.hide(300);
    }
}
document.addEventListener('DOMContentLoaded', function () {
    var disabledDossier = document.getElementById("download-dossier");
    disabledDossier.classList.remove('disabled-dossier');
});
function loadCourseContent() {
    if (courseContentLoaded) {
        return;
    }

    courseContentLoaded = true;
    $.ajax({
        url: tech.core.getInternationalUrl('/Course/Contents'),
        type: 'GET',
        data: {
            courseUrl: domCourseContent.data('course-url'),
            courseFullUrl: domCourseContent.data('course-full-url'),
            facultyUrl: domCourseContent.data('faculty-url'),
            specialities: domCourseContent.data('specialities'),
            specialitiesUrls: domCourseContent.data('specialities-urls'),
            courseCode: domCourseContent.data('course-code'),
            categoryUrl: domCourseContent.data('category-url'),
            courseArea: domCourseContent.data('course-area'),
            courseType: domCourseContent.data('course-type'),
            originalCourseId: domCourseContent.data('course-original-id'),
            courseCurrency: domCourseContent.data('course-currency'),
            courseTypeName: domCourseContent.data('course-typename'),
            dossier: domCourseContent.data('course-dossier'),
            price: domCourseContent.data('course-price'),
            courseTitle: domCourseContent.data('course-title'),
            countryCode: tech.core.getSelectedCountryCode(),
            index: $('.scrollspy-index-render-li').length
        },
        success: function(data) {
            if (data) {

                var temp = $('<div/>').html(data);
                // Append scripts to DOM
                body.append(temp.find('script'));
                // Append style to DOM
                body.append(temp.find('style'));
                // Append modals to DOM
                body.append(temp.find('.modal'));
                // Update modal's course price
                $('input[name="coursePrice"]').val($('#course-discount').text() || $('#course-pvp').text());
                // bind modal's checkboxes
                tech.core.bindCustomCheckbox();
                // Append course content to DOM
                itemToLoadCourseContent.after(temp.find('#content').html());
                itemToLoadCourseContent.remove();
                $('.index-items-div ul').append(temp.find('#header').html());
                // Include the class with more padding top for tittle section

                // init lazy loading items                
                tech.lazyLoad.initLazyLoad('.lazyBackground', true);
                tech.lazyLoad.initLazyLoad('video.lazy', true);
                tech.lazyLoad.initLazyLoad('img.lazy', true);
                tech.lazyLoad.initLazyLoad('.scrollspy-content-section .anim-trigger', true);
                tech.lazyLoad.initLazyLoad('.swiper-container', true);
                // bind events of new content 
                initAfterAjax(true);
                // refresh scrollspy
                $('body').scrollspy('refresh');
                // clean up temp wrapper
                temp.remove();
                SendCourseViewContentGtm();
            }
        }
    })
    var box = $('.img-box');
    box.attr('src', box.data('box'));

    body.off('click', null, loadCourseContent);
    body.off('keydown', null, loadCourseContent);
    body.off('mousemove', null, loadCourseContent);
    body.off('touchstart', null, loadCourseContent);


}

function bindModals() {
    $('[data-toggle="modal"]').on('click', function() {
        var $this = $(this);
        var modal = null;
        if ($this.is('[data-target]')) {
            modal = $($(this).data('target'));
        } else if ($this.is('a')) {
            modal = $($(this).attr('href'))
        }
        modal.on('shown.bs.modal', function() {
            tech.phone.setDefaultPhoneExtension(modal[0].id);
            $(this).find('label').addClass('active')
        }).on('hidden.bs.modal', function() {
            $(this).find('label').removeClass('active')
        })

        modal.modal('show');
    })

    // $(document).on('click', '.modal form input , .modal form button', function formFirstClick() {
    //     tech.core.loadFormValidator('#moreInfoModal', function() {
    //         tech.core.loadFormValidator('#dossierForm');
    //         tech.core.loadFormValidator('#welcomeModal')
    //         dossierValidatorLoaded = true;
    //         moreInfoValidatorLoaded = true;
    //     })

    //     $(document).off('click', '.modal form input , .modal form button', formFirstClick)
    // });
}

function adjustDiscountBadgeFontSize(ref) {
    var target = $(ref);
    var discountSize = $.trim(target.text()).length;
    var fontSize = 50;
    if (discountSize > 9) {
        fontSize = 25;
    } else if (discountSize > 8) {
        fontSize = 28;
    } else if (discountSize > 7) {
        fontSize = 33;
    } else if (discountSize > 6) {
        fontSize = 35;
    } else if (discountSize >= 5) {
        fontSize = 37;
    } else if (discountSize <= 4) {
        fontSize = 40;
    }
    if ($(window).width() < 768) {
        fontSize -= (discountSize < 10) ? 9 : 13;
    }
    else if ($(window).width() > 768) {
        fontSize -= (discountSize > 7) ? 5 : 0;
    }
    target.css('font-size', fontSize + 'px')
}

function calculateAnimationOffsets() {
    offsetCourseDetailsElem = courseDetailElem.offset().top - $(window).height();
    offsetToActivateMenuTitle = courseTitle.offset().top + courseTitle.height();
    offsetToActivateFloatingBadge = dossierDownloadTopBtn.offset().top;
    offsetToActivateCourseDossierDownloadBtn = scrollSpyContainer.offset().top;
    offsetFooter = footer.offset().top;
    // if (!courseContentLoaded) {
    //     offsetToLoadCourseContent = itemToLoadCourseContent.offset().top;
    // }
}



export function moreInfoDetail() {
    var innerMoreInfoDetail = function() {
        var form = $('#moreInfoModal');
        let validForm = form.valid();
        var extensionEnabled = document.getElementById("extensionInputValue").value;

        if (extensionEnabled) {
            var translations = JSON.parse(document.getElementById('translations').value.replaceAll("##", "'"));
            var vanillaForm = document.getElementById("moreInfoModal");
            var countrySelected = vanillaForm.querySelector('#tech-phone-countries-button-value').getAttribute("user-country");
            var phoneNumber = phoneUtil.parseAndKeepRawInput(vanillaForm.querySelector(".welcome-phone-input input").value, countrySelected);


            if (validatePhone(phoneNumber, countrySelected) === false) {
                let errorSpan = vanillaForm.querySelector("#welcome-phone-error-span");
                errorSpan.classList.remove('field-validation-valid');
                errorSpan.innerText = translations.tlfError;
                validForm = false;
            }
        }
        if (validForm) {
            var btn = form.find('button');

            btn.html(btn.data('loading-text')).prop('disabled', true);

            var name = $('#moreInfoModal #name').val();
            var phone = $('#moreInfoModal #phone').val();
            var email = $('#moreInfoModal #email').val();
            var text = $('#moreInfoModal #text').val();
            var coursePrice = $('#priceRefreshed').val();
            var currency = $('#DetailCurrency').val();
            var specialities = $('#DetailSpecialities').val();
            var faculty = $('#moreInfoModal input[name="faculty"]').val();
            

            var currencyCode = document.getElementById('course-data-info').getAttribute('data-course-currency');
            var courseCode = document.getElementById('course-data-info').getAttribute('data-course-code');
            var coursePriceValue = document.getElementById('course-data-info').getAttribute('data-course-price-value');

            var courseTitle = $('#DetailCourseTitle').val();
            var courseType = $('#DetailCourseType').val();

            $('#moreInfoModal input[name="CurrentUrl"]').val(window.location.href);


            $.ajax({
                // headers: {
                //     "RequestVerificationToken": form.find("input[name='__RequestVerificationToken']").val()
                // },
                type: 'POST',
                url: tech.core.getInternationalUrl('/Course/CourseMoreInfoModalData'),
                data: {
                    name: name,
                    phoneNumber: phone,
                    email: email,
                    text: text,
                    courseTitle: courseTitle,
                    courseType: courseType,
                    coursePrice: coursePrice,
                    currency: currency,
                    specialities: specialities,
                    faculty: faculty,
                    'tech-hpot': $('#moreInfoModal input[name="tech-hpot"]').val(),
                    CurrentUrl: $('#DetailUrlCourse').val(),
                    CurrencyCode: currencyCode,
                    CourseCode: courseCode,
                    PriceValue: coursePriceValue
                },
                success: function(content) {
                    //tech.core.sendGAEvent({
                    //    event: 'VirtualPageview',
                    //    virtualPageUrl: '/contacto-enviado',
                    //    virtualPageTitle: 'Contacto enviado'
                    //})
                    var vanForm = document.getElementById('moreInfoModal');
                    tech.core.setTrackingCookie(vanForm);
                    var target = $('#more-info-modal .modal-body-wrap');
                    target.children().hide();
                    target.append(content);
                },
                complete: function() {
                    btn.html(btn.data('text')).prop('disabled', false);
                },
                error: function() {
                    form.find('.general-validation-error').text('Debes rellenar todos los campos obligatorios.');
                }
            })
        }
    }

    if (!moreInfoValidatorLoaded) {
        tech.core.loadFormValidator('#moreInfoModal', innerMoreInfoDetail)
        moreInfoValidatorLoaded = true;
    } else {
        innerMoreInfoDetail();
    }
}

export function sendDossier() {
    var innerSendDossier = function() {
        var form = $("#dossierForm");
        let validForm = form.valid();
        var extensionEnabled = document.getElementById("extensionInputValue").value;

        if (extensionEnabled) {
            var translations = JSON.parse(document.getElementById('translations').value.replaceAll("##", "'"));
            var vanillaForm = document.getElementById("dossierForm");
            var countrySelected = vanillaForm.querySelector('#tech-phone-countries-button-value').getAttribute("user-country");
            var phoneNumber = phoneUtil.parseAndKeepRawInput(vanillaForm.querySelector(".welcome-phone-input input").value, countrySelected);


            if (validatePhone(phoneNumber, countrySelected) === false) {
                let errorSpan = vanillaForm.querySelector("#welcome-phone-error-span");
                errorSpan.classList.remove('field-validation-valid');
                errorSpan.innerText = translations.tlfError;
                validForm = false;
            }
        }
        if (validForm) {

            var btn = form.find('button');

            btn.html(btn.data('loading-text')).prop('disabled', true);

            const name = $('#dossierForm #name').val();
            const phone = $('#dossierForm #contact-phone').val();
            const email = $('#dossierForm #e-mail').val();
            var area = $('#DetailArea').val();
            var coursePrice = $('#priceRefreshed').val();
            var courseTitle = $('#DetailCourseTitle').val();
            var courseType = $('#DetailCourseType').val();
            var originalCourseId = $('#DetailOriginalCourseId').val();
            var dossier = $('#DetailDossier').val();
            var currency = $('#DetailCurrency').val();
            var urlCourse = $('#DetailUrlCourse').val();
            var specialities = $('#DetailSpecialities').val();
            
            console.log("Dossier PARAMS", area, coursePrice, courseTitle, courseType, originalCourseId, dossier, currency, urlCourse, specialities);

            var currencyCode = document.getElementById('course-data-info').getAttribute('data-course-currency');
            var courseCode = document.getElementById('course-data-info').getAttribute('data-course-code');
            var coursePriceValue = document.getElementById('course-data-info').getAttribute('data-course-price-value');

            const url = window.location.host;

            $('#dossierForm input[name="CurrentUrl"]').val(window.location.href);


            const course = {
                area: area,
                coursePrice: coursePrice,
                courseTitle: courseTitle,
                courseType: courseType,
                originalCourseId: originalCourseId,
                currency: currency,
                url: urlCourse,
                specialities: specialities,
                CourseCode: courseCode,
                CurrencyCode: currencyCode,
                PriceValue: coursePriceValue
            };

            $.ajax({
                type: 'POST',
                url: tech.core.getInternationalUrl('/Course/GetDossier'),
                data: {
                    model: {
                        DossierUrl: dossier,
                        Name: name,
                        PhoneNumber: phone,
                        Email: email,
                        Url: url,
                        Course: course,
                        CurrentUrl: $('#dossierForm input[name="CurrentUrl"]').val()
                    },
                    'tech-hpot': $('#dossierForm input[name="tech-hpot"]').val()
                },
                success: function(content) {
                    var vanForm = document.getElementById('dossierForm');
                    tech.core.setTrackingCookie(vanForm);
                    var target = $('#dossier-modal .modal-body');
                    target.children().hide();
                    target.append(content);
                },
                complete: function() {
                    btn.html(btn.data('text')).prop('disabled', false);
                },
                error: function() {
                    form.find('.general-validation-error').text('Debes rellenar todos los campos obligatorios.');
                }
            })
        }
    };

    if (!dossierValidatorLoaded) {
        tech.core.loadFormValidator('#dossierForm', innerSendDossier)
        dossierValidatorLoaded = true;
    } else {
        innerSendDossier();
    }

}

export function sendSeePrice() {
    var innerSendSeePrice = function() {
        var form = $("#seePriceForm");
        let validForm = form.valid();
        var extensionEnabled = document.getElementById("extensionInputValue").value;

        if (extensionEnabled) {
            var translations = JSON.parse(document.getElementById('translations').value.replaceAll("##", "'"));
            var vanillaForm = document.getElementById("seePriceForm");
            var countrySelected = vanillaForm.querySelector('#tech-phone-countries-button-value').getAttribute("user-country");
            var phoneNumber = phoneUtil.parseAndKeepRawInput(vanillaForm.querySelector(".welcome-phone-input input").value, countrySelected);

            if (validatePhone(phoneNumber, countrySelected) === false) {
                let errorSpan = vanillaForm.querySelector("#welcome-phone-error-span");
                errorSpan.classList.remove('field-validation-valid');
                errorSpan.innerText = translations.tlfError;
                validForm = false;
            }
        }
        if (validForm) {

            var btn = form.find('button');

            btn.html(btn.data('loading-text')).prop('disabled', true);

            const name = $('#seePriceForm #name').val();
            const phone = $('#seePriceForm #contact-phone').val();
            const email = $('#seePriceForm #e-mail').val();
            var area = $('#DetailArea').val();
            var coursePrice = $('#priceRefreshed').val();
            var courseTitle = $('#DetailCourseTitle').val();
            var courseType = $('#DetailCourseType').val();
            var originalCourseId = $('#DetailOriginalCourseId').val();
            var currency = $('#DetailCurrency').val();
            var urlCourse = $('#DetailUrlCourse').val();
            var specialities = $('#DetailSpecialities').val();
            var coursePriceValue = document.getElementById('course-data-info').getAttribute('data-course-price-value');

            const url = window.location.host;

            const course = {
                area: area,
                coursePrice: coursePrice,
                courseTitle: courseTitle,
                courseType: courseType,
                originalCourseId: originalCourseId,
                currency: currency,
                url: urlCourse,
                specialities: specialities,
                PriceValue: coursePriceValue
            };

            $.ajax({
                type: 'POST',
                url: tech.core.getInternationalUrl('/Course/SeePrice'),
                data: {
                    model: {
                        Name: name,
                        PhoneNumber: phone,
                        Email: email,
                        Url: url,
                        Course: course,
                        CurrentUrl: $('#seePriceForm input[name="CurrentUrl"]').val()
                    },
                    'tech-hpot': $('#seePriceForm input[name="tech-hpot"]').val()
                },
                success: function(content) {
                    var vanForm = document.getElementById('seePriceForm');
                    tech.core.setTrackingCookie(vanForm);
                    var target = $('#seePrice-modal');
                    target.append(content);
                    document.getElementById("seePrice-close-button").click();
                    tech.core.setCookie("seePrice", "true", 259200000);
                    showPrice();
                },
                complete: function() {
                    btn.html(btn.data('text')).prop('disabled', false);
                },
                error: function() {
                    form.find('.general-validation-error').text('Debes rellenar todos los campos obligatorios.');
                }
            })
        }
    };
    if (!seePriceValidatorLoaded) {
        tech.core.loadFormValidator('#seePriceForm', innerSendSeePrice)
        seePriceValidatorLoaded = true;
    } else {
        innerSendSeePrice();
    }
}

function showPrice() {
    if (splitPaymentOnlyPrice) {
        $('#course-pvp').text(priceFormatString(recurrentFeeFormatPrice, currencyPrice, currencyFormatPrice));
        $('.course-main-data.price-section .course-value').html(createPriceHtml(priceFormatString(recurrentFeeFormatPrice, currencyPrice, currencyFormatPrice), false));
    } else {
        $('#course-pvp').text(priceFormatPrice);
        $('.course-main-data.price-section .course-value').html(createPriceHtml(priceFormatPrice));
    }
}

export function sendDemo() {
    var innerSendDemo = function() {
        var form = $("#demoForm");
        let validForm = form.valid();
        var extensionEnabled = document.getElementById("extensionInputValue").value;

        if (extensionEnabled) {
            var translations = JSON.parse(document.getElementById('translations').value.replaceAll("##", "'"));
            var vanillaForm = document.getElementById("welcomeForm");
            var countrySelected = vanillaForm.querySelector('#tech-phone-countries-button-value').getAttribute("user-country");
            var phoneNumber = phoneUtil.parseAndKeepRawInput(vanillaForm.querySelector(".welcome-phone-input input").value, countrySelected);

            if (validatePhone(phoneNumber, countrySelected) === false) {
                let errorSpan = document.getElementById("welcome-phone-error-span");
                errorSpan.classList.remove('field-validation-valid');
                errorSpan.innerText = translations.tlfError;
                validForm = false;
            }
        }
        if (validForm) {

            var btn = form.find('button');

            btn.html(btn.data('loading-text')).prop('disabled', true);

            const name = $('#demoForm #name').val();
            const phone = $('#demoForm #contact-phone').val();
            const email = $('#demoForm #e-mail').val();
            var area = $('#demoForm #area').val();
            var coursePrice = $('#priceRefreshed').val();
            var courseTitle = $('#demoForm #courseTitle').val();
            var courseType = $('#demoForm #courseType').val();
            var originalCourseId = $('#demoForm #originalCourseId').val();
            var dossier = $('#demoForm #dossier').val();
            var currency = $('#demoForm #currency').val();
            var urlCourse = $('#demoForm #url-course').val();
            var specialities = $('#demoForm #specialities').val();

            const url = window.location.host;

            const course = {
                area: area,
                coursePrice: coursePrice,
                courseTitle: courseTitle,
                courseType: courseType,
                originalCourseId: originalCourseId,
                currency: currency,
                url: urlCourse,
                specialities: specialities
            };

            $.ajax({
                type: 'POST',
                url: tech.core.getInternationalUrl('/Course/GetDemo'),
                data: {
                    model: {
                        DossierUrl: dossier,
                        Name: name,
                        PhoneNumber: phone,
                        Email: email,
                        Url: url,
                        Course: course,
                        CurrentUrl: $('#demoForm input[name="CurrentUrl"]').val()
                    },
                    'tech-hpot': $('#demoForm input[name="tech-hpot"]').val()
                },
                success: function(content) {
                    var vanForm = document.getElementById('demoForm');
                    tech.core.setTrackingCookie(vanForm);
                    var target = $('#demo-modal .modal-body');
                    target.children().hide();
                    target.append(content);
                },
                complete: function() {
                    btn.html(btn.data('text')).prop('disabled', false);
                },
                error: function() {
                    form.find('.general-validation-error').text('Debes rellenar todos los campos obligatorios.');
                }
            })
        }
    };

    if (!demoValidatorLoaded) {
        tech.core.loadFormValidator('#demoForm', innerSendDemo)
        demoValidatorLoaded = true;
    } else {
        innerSendDemo();
    }

}

export function toggleCourseDetailSectionMenu() {
    var elem = $('.scrollspy .index.card');
    var wasOpened = elem.is('.open');
    elem.toggleClass('open');

    if (wasOpened) {
        $(window).off('scroll', closeSubMenu);
        elem.find('a').off('click', closeSubMenu)
    } else {
        var closeSubMenu = function() {
            elem.removeClass('open');
            $(window).off('scroll', closeSubMenu);
        };

        $(window).on('scroll', closeSubMenu)
        elem.find('a').on('click', closeSubMenu)
    }
}

function initCarousel() {
    var carouselNext = $('.carousel-control-next');
    var carouselPrev = $('.carousel-control-prev');
    carouselPrev.hide();
    $('#course-carousel-home').on('slide.bs.carousel', function(ev) {

        activeSlideVideo = ev.to == 1;

        var carIt = $('.carousel-inner > .carousel-item');
        if (carIt.length - 1 == ev.to) {
            carouselNext.hide();
            carouselPrev.show();
        } else if (ev.to == 0) {
            carouselPrev.hide();
            carouselNext.show();
        } else {
            carouselPrev.show();
        }
        if ($('#iframeCarousel').length == 0) {
            $.ajax({
                type: 'POST',
                url: '/Course/GetVideoView',
                data: { videoUrl: domCourseContent.data('video-url') },
                success: function(content) {
                    var courseDetailVideo = $('.carousel-inner .loader');
                    courseDetailVideo.after(content);
                    tech.core.loadScripts(['https://player.vimeo.com/api/player.js'], function() {
                        var options = {
                            responsive: true,
                            autoplay: true,
                            muted: true,
                            controls: false
                        };
                        player = new Vimeo.Player('iframeCarousel', options);
                        tech.core.onAudioToggleClick(player);

                        showHideBadge(ev);

                        setTimeout(function() {
                            courseDetailVideo.addClass('course-carousel-loader-animation');
                        }, 100);
                        setTimeout(function() {
                            courseDetailVideo.remove();
                        }, 600);
                        //player.on('play', function () {

                        //    player.off('play');
                        //});
                        player.on('ended', function() {
                            $('#course-carousel-home').carousel('prev');
                            $('#course-carousel-home').carousel('pause');
                        });
                    });
                }
            })
        } else {
            if (ev.from != ev.to && ev.to == 1) {
                player.getEnded().then(function(ended) {
                    if (ended) {
                        player.play();
                    }
                });
            }
            showHideBadge(ev);
        }
    });

    var showHideBadge = function(ev) {
        if (ev.to == 1) {
            coursePriceFloatingBadge.addClass('fadeOut');
        } else {
            coursePriceFloatingBadge.removeClass('fadeOut floating');
        }
    }
}

$(function() {

    initCarousel();

    //Update course main information
    getCourseGeneralInformationData($('.course-detail-page').data('course-code'));

    var position = $(window).scrollTop();

    moveOnScroll(position, 0);

    bindModals();

    $(window).scroll(function() {
        var scroll = $(window).scrollTop();
        moveOnScroll(scroll, position);
        position = scroll;
    });

    $(window).on('load', calculateAnimationOffsets)

    $('#welcomeForm input[name="CourseType"]').val($('.course-detail-page').data('course-type'))
    $('#welcomeForm input[name="CourseTitle"]').val($('.course-detail-page').data('course-title'))

    $('.modal-prevent-nav').on('click', function(ev) {
        ev.preventDefault();
        ev.stopPropagation();
        $($(this).data('target')).modal('show');
    })

    body.one('click', loadCourseContent);
    body.one('keydown', loadCourseContent);
    body.one('mousemove', loadCourseContent);
    body.one('touchstart', loadCourseContent);

    initAfterAjax();

    $('body').scrollspy({ target: '#scrollspy-nav' })
});

function initAfterAjax(recalculateOffsets) {
    $('.img-link').on('click', function(ev) {
        // Prevent img links from open
        ev.preventDefault();
        ev.stopPropagation();
        return false;
    })

    if ($('#diploma').length > 0) {
        $('#diploma').on('click', function() {
            $('<a/>').attr('target', '_blank').attr('href', $('.course-detail-page').data('diploma-url')).get(0).click()
        })
    }
    if ($('#diploma-alternative').length > 0) {
        $('#diploma-alternative').on('click', function () {
            $('<a/>').attr('target', '_blank').attr('href', $('.course-detail-page').data('diploma-alternative-url')).get(0).click()
        })
    }

    if (recalculateOffsets) {
        calculateAnimationOffsets();
    }
}



function getCourseGeneralInformationData(courseCode) {
    var ctbID = document.getElementById("ctbID").value;
    var countryCode = tech.core.getSelectedCountryCode();
    var currencyCountryCode = tech.core.getCookie("userCountryCode") != null ? tech.core.getCookie("userCountryCode") : countryCode;
    var languageCode = tech.core.getCookie("tech.language") != null ? tech.core.getCookie("tech.language") : "es";
    $.ajax({
        type: 'GET',
        url: tech.core.getInternationalUrl('/Course/GetCourseMainInformation'),
        data: {
            courseCode: courseCode,
            countryCode: countryCode,
            currencyCountryCode: currencyCountryCode,
            languageCode: languageCode,
        },
        success: function(response) {
            var coursePriceFormat = '';
            if (response.data.duration != null) {
                $('#course-duration').text(response.data.duration);
            }
            if (response.data.enrollmentPeriodDate != null) {
                $('#enrollment-period-date').text(response.data.enrollmentPeriodDate).css('padding-left', '5px');
                $('.badge-enrolment-period-date').text(response.data.enrollmentPeriodDate);
            }
            if (response.data.startDate != null) {
                $('#course-start-date').text(response.data.startDate);
                $('#course-enroll-start').text(getEnrolmentMessage(response.data.startDate));
            }
            if (response.data.finishDate != null) {
                $('#course-finish-date').text(response.data.finishDate);
            }
            if (response.data.credits != null && response.data.credits > 0) {
                $('#course-credits').text(response.data.credits + " " + response.data.creditAcronym);
            }
            if (response.data.hours != null && response.data.hours > 0) {
                $('#course-hours').text(response.data.hours);
            }
            console.log(response.data.isSubscription);
            if (response.data.isSubscription === true) {
                $('#course-fees-count').text(priceFormatString(response.data.initialFeeFormat.toString(), response.data.currency, response.data.currencyFormat))
            } else {
                $('#course-fees-count').text(response.data.feesCount).css('padding-right', '5px');
            }

            $('.before-price').remove();

            if (response.data.price != null && response.data.price > 0) {
                coursePriceFormat = response.data.priceFormat;
                recurrentFeeFormatPrice = response.data.recurrentFeeFormat.toString();
                currencyPrice = response.data.currency;
                currencyFormatPrice = response.data.currencyFormat;
                priceFormatPrice = response.data.priceFormat;
                splitPaymentOnlyPrice = response.data.splitPaymentOnly;
                console.log(response.data)
                if (tech.core.getCookie("seePrice").length > 0) {
                    if (response.data.isSubscription) {
                        $('#course-pvp').text(priceFormatString(response.data.recurrentFeeFormat.toString(), response.data.currency, response.data.currencyFormat));
                        $('.course-main-data.price-section .course-value').html(createPriceHtml(priceFormatString(response.data.recurrentFeeFormat.toString(), response.data.currency, response.data.currencyFormat), false));
                    } else {
                        $('#course-pvp').text(coursePriceFormat);
                        $('.course-main-data.price-section .course-value').html(createPriceHtml(coursePriceFormat));
                    }
                }


                $('#badge-course-price').text(coursePriceFormat);
                $('.modal input[name="coursePrice"]').val(coursePriceFormat);
                $('#priceRefreshed').val(coursePriceFormat);
                $('#course-data-info').attr('course-price', coursePriceFormat);

                $('#course-data-info').attr('data-course-price-value', response.data.price);
            }
            var badge = $('#placeholderBadge');
            if (response.data.discount != null && response.data.discount.totalDiscount != null && response.data.discount.totalDiscount > 0) {
                var courseTotalBadge = response.data.priceFormat;
                const discountFormat = response.data.discount.totalDiscountFormat;
                $('#course-discount').text(discountFormat).css('padding-left', '5px');
                badge.html(createBadgeHtml(discountFormat, courseTotalBadge, response.data.enrollmentPeriodDate));
                adjustDiscountBadgeFontSize('.discount-badge .discount')
                $('.modal input[name="coursePrice"]').val(discountFormat);
                $('#priceRefreshed').val(coursePriceFormat);
                $('#course-data-info').attr('course-price', discountFormat);

                $('.course-main-data.price-section .course-property').append(createBeforeDiscountPriceHtml(coursePriceFormat));
                $('.course-main-data.price-section .course-value').html(createPriceHtml(discountFormat, true));
            } else if (response.data.recurrentPromoFee != null && response.data.recurrentPromoFee > 0) {
                var priceFormated = priceFormatString(response.data.recurrentPromoFeeFormat, response.data.currency, response.data.currencyFormat);
                badge.html(createBadgeHtmlPromoFee(priceFormated, response.data.enrollmentPeriodDate));
                adjustDiscountBadgeFontSize('.discount-badge .discount')

            }
            checkerVideoStyleClass();

            let track = tech.core.trackingCookieEnabled();
            if (track) {
                tech.core.sendTrackLead();
            }

            coursePriceFloatingBadge = $('app-discount-badge');
        }
    });
}

function checkerVideoStyleClass() {
    if ($('app-discount-badge').data('videostyles') === true) {
        $('app-discount-badge').addClass('videoStyles');
    }
}

function createPriceHtml(price, isDiscount) {
    if (isDiscount) {
        var nowText = $('.course-main-data.price-section').data('now-text') || 'ahora';
        return nowText + ' <span id="course-discount">' + price + '</span>';
    } else {
        return '<span id="course-pvp" style="white-space: nowrap">' + price + '</span>';
    }
}

function createBeforeDiscountPriceHtml(coursePrice) {
    var beforeText = $('.course-main-data.price-section').data('before-text') || 'antes';
    return '\
        <span class="color-white">\
            ' + beforeText + ' \
            <span class="struckPrice">\
                ' + coursePrice + ' \
            </span>\
        </span>';
}

function createBadgeHtmlPromoFee(priceFormated, enrolmentPeriodDate) {
    var originData = $('#placeholderBadge');
    return '<app-discount-badge class="animated fadeIn" data-videostyles="' + videoStylesBadge() + '">\n' +
        '<a rel="nofollow" href=' + originData.data('url') + '>\n' +
        '<div class="discount-badge contain">\n' +
        '<div class="discount-badge-wrapper" style="background-color: rgb(65, 148, 206);">\n' +
        '<div class="title discount-badge-wrapper-title">' + originData.data('desdetitle') + '<span class="title-bold"> ' + originData.data('solotitle') + ' </span></div>\n' +
        '<div class="discount" id="badge-course-recurrent-promo-fee">\n' +
        priceFormated +
        '</div>\n' +
        '<div class="price">\n' +
        originData.data('detallepreciomensual') +
        '</div>\n' +
        '<div class="valid-to">' + originData.data('fechaperiodomatriculacion') + ' <span class="badge-enrolment-period-date">' + enrolmentPeriodDate +
        '</div>\n' +
        '</div>\n' +
        '</a>\n' +
        '</app-discount-badge>'
}

function createBadgeHtml(discountFormat, coursePriceFormat, enrolmentPeriodDate) {
    var originData = $('#placeholderBadge');
    return '<app-discount-badge class="animated fadeIn" data-videostyles="' + videoStylesBadge() + '">\n' +
        '<a rel="nofollow" href=' + originData.data('url') + '>\n' +
        '<div class="discount-badge contain">\n' +
        '<div class="discount-badge-wrapper" style="background-color: rgb(65, 148, 206);">\n' +
        '<div class="title discount-badge-wrapper-title">' + originData.data('ahoratitle') + '<span class="title-bold"> ' + originData.data('solotitle') + '</span></div>\n' +
        '<div class="discount" id="badge-course-discount"> \n' +
        discountFormat +
        '</div>\n' +
        '<div class="price">\n' +
        originData.data('antestitle') +
        '<span class="price-line-through" id="badge-course-price"> ' + coursePriceFormat + '</span>\n' +
        '</div>\n' +
        '<div class="valid-to">' + originData.data('fechaperiodomatriculacion') + '<span class="badge-enrolment-period-date"> ' + enrolmentPeriodDate + '</span></div>\n' +
        '</div>' +
        '</div>\n' +
        '</a>\n' +
        '</app-discount-badge>';;

}

function videoStylesBadge() {
    if ($('.iframe-video.video').length > 0) {
        return true;
    }
    return false;
}

function priceFormatString(price, currency, currencyFormat) {
    return currencyFormat.replace('{currency}', currency).replace('{value}', price);
}

function getEnrolmentMessage(startDate) {
    if (startDate) {
        if (startDate.indexOf("/") > 0) {
            const day = +startDate.split('/')[0];
            var text = $('#course-enroll-start').data('enrolment-starts-next-text');
            if (day === new Date().getDate()) {
                text = $('#course-enroll-start').data('enrolment-starts-text');
            }
            return text + ' ' + startDate;
        } else {
            return startDate;
        }
    }
}

export function onErrorFunction(src, obj) {
    var srcObj = $(obj).attr('src');
    if (src !== srcObj) {
        $(obj).attr('src', src);
    }
}